<template>
  <div class="landing">
    <div class="introduction-image">
      <div class="centered-text position-absolute">
        <h1>HN Accountancy</h1>
        <p>Persoonlijke aandacht voor uw ondernemerschap, samen in goede conditie de toekomst tegemoet!</p>
      </div>
      <img alt="HN Accountancy" src="/img/personal/running-banner.webp">
    </div>
    <div class="container py-5">
      <div class="container">
        <div class="row g-5">
          <div class="col-lg-6 wow fadeIn itemlist">
            <h1 class="display-5 mb-4" style="font-size: 32px; font-family: 'DM Sans'">Persoonlijke aandacht voor uw
              ondernemerschap</h1>
            <p>Als ondernemer wilt u vooruitkijken, groeien en de juiste beslissingen nemen. Daar hoort een solide
              financiële basis bij. HN Accountancy biedt u niet alleen een helder inzicht in uw cijfers, maar ook
              persoonlijke begeleiding en strategisch advies.
              <br>
              <br>
              Persoonlijke aandacht staat bij HN Accountancy centraal. Met mijn kennis en ervaring zorg ik dat uw
              administratie efficiënt is ingericht, uw fiscale zaken
              optimaal zijn geregeld en uw jaarcijfers geen verrassingen bevatten. Zo kunt u met vertrouwen ondernemen
              en uw focus houden op wat echt belangrijk is.
              <br>
              <br>
              Samen werken we aan uw toekomst!
            </p>
            <br>
          </div>
          <div class="col-lg-6 wow fadeIn">
            <img alt="" class="w-100" src="/img/personal/bluesuit.webp" style="    max-height: 800px;
    object-fit: cover; border-radius: 20px">
          </div>
        </div>
      </div>
    </div>

    <section class="doelen">
      <div class="container" style="padding-top: 0;">
        <div class="doelen-headline df">
          <div class="left-side">
            <h4>Diensten</h4>
          </div>
          <div class="right-side">
          </div>
        </div>
        <div class="doelen-content">
          <router-link to="/diensten#accountancy">
            <div class="single-doel df">
              <div class="left-side">
                <svg id="fi_1570887" height="480pt" viewBox="0 0 480 480" width="480pt"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m184 288c-44.183594 0-80 35.816406-80 80s35.816406 80 80 80 80-35.816406 80-80c-.046875-44.164062-35.835938-79.953125-80-80zm0 144c-35.347656 0-64-28.652344-64-64s28.652344-64 64-64 64 28.652344 64 64c-.039062 35.328125-28.671875 63.960938-64 64zm0 0"></path>
                  <path
                      d="m184 344c9.769531 0 16 4.734375 16 8h16c0-11.367188-10.070312-20.574219-24-23.199219v-8.800781h-16v8.800781c-13.929688 2.605469-24 11.816407-24 23.199219 0 13.464844 14.054688 24 32 24 9.769531 0 16 4.734375 16 8s-6.230469 8-16 8-16-4.734375-16-8h-16c0 11.367188 10.070312 20.574219 24 23.199219v8.800781h16v-8.800781c13.929688-2.605469 24-11.816407 24-23.199219 0-13.464844-14.054688-24-32-24-9.769531 0-16-4.734375-16-8s6.230469-8 16-8zm0 0"></path>
                  <path
                      d="m408 464h-336v-192h128c13.253906 0 24-10.746094 24-24v-200h88v96h96v112h16v-123.3125l-100.6875-100.6875h-99.3125v-8c0-13.253906-10.746094-24-24-24h-176c-13.253906 0-24 10.746094-24 24v224c0 13.253906 10.746094 24 24 24h32v208h368v-112h-16zm-80-404.6875 68.6875 68.6875h-68.6875zm-312 188.6875v-224c0-4.417969 3.582031-8 8-8h176c4.417969 0 8 3.582031 8 8v224c0 4.417969-3.582031 8-8 8h-176c-4.417969 0-8-3.582031-8-8zm0 0"></path>
                  <path d="m256 200h16v16h-16zm0 0"></path>
                  <path d="m288 200h96v16h-96zm0 0"></path>
                  <path d="m256 168h16v16h-16zm0 0"></path>
                  <path d="m288 168h96v16h-96zm0 0"></path>
                  <path d="m256 232h16v16h-16zm0 0"></path>
                  <path d="m288 232h96v16h-96zm0 0"></path>
                  <path d="m256 264h16v16h-16zm0 0"></path>
                  <path d="m288 264h96v16h-96zm0 0"></path>
                  <path d="m200 24h-176v56h176zm-16 40h-144v-24h144zm0 0"></path>
                  <path
                      d="m64 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m120 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m176 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m64 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m120 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m176 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m64 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m120 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m176 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0"></path>
                  <path
                      d="m472.734375 255.265625c-9.496094-9.066406-24.4375-9.066406-33.933594 0l-137.144531 137.140625c-.664062.671875-1.207031 1.453125-1.601562 2.3125l-19.3125 41.9375c-1.394532 3.039062-.75 6.628906 1.617187 8.992188 2.363281 2.367187 5.953125 3.011718 8.992187 1.617187l41.9375-19.3125c.859376-.394531 1.640626-.933594 2.3125-1.601563l137.132813-137.144531c9.375-9.371093 9.375-24.570312 0-33.941406zm-147.445313 158.75-20.960937 9.65625 9.65625-20.960937 102.253906-102.261719 11.3125 11.3125zm113.597657-113.601563-11.3125-11.308593 5.601562-5.601563 11.3125 11.3125zm22.5625-22.558593-5.65625 5.65625-11.3125-11.3125 5.664062-5.65625c3.160157-3.023438 8.140625-3.023438 11.304688 0 3.121093 3.125 3.121093 8.1875 0 11.3125zm0 0"></path>
                </svg>
              </div>
              <div class="right-side">
                <b>Accountancy</b>
              </div>
            </div>
          </router-link>
          <router-link to="/diensten#advies">
            <div class="single-doel df">
              <div class="left-side">
                <svg id="fi_11524516" enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m263.9 286.62c-.04-53.31-43.42-96.66-96.73-96.66s-96.69 43.35-96.73 96.66c-.9 39.28 17.12 60.3 33.01 78.85 10.65 12.43 19.85 23.16 21.9 37.63.09.65.3 1.26.58 1.82v34.91 25.46c0 9.99 8.13 18.12 18.12 18.12h46.88c9.99 0 18.12-8.13 18.12-18.12v-25.46-37.08c2.15-14.3 11.27-24.97 21.84-37.29 15.9-18.54 33.91-39.56 33.01-78.84zm-116.48 8.12h-11.47c-6.33 0-11.47-5.15-11.47-11.47 0-6.33 5.15-11.47 11.47-11.47 6.33 0 11.47 5.15 11.47 11.47zm49.63 113.52v25.58h-59.11v-25.58zm0 57.04c0 3.37-2.74 6.12-6.12 6.12h-46.88c-3.37 0-6.12-2.74-6.12-6.12v-19.46h59.11v19.46zm24.73-107.64c-10.26 11.97-20 23.34-23.68 38.6h-10.52v-89.52h11.47c12.94 0 23.47-10.53 23.47-23.47s-10.53-23.47-23.47-23.47c-12.94 0-23.47 10.53-23.47 23.47v17.47 95.52h-16.15v-95.52-17.47c0-12.94-10.53-23.47-23.47-23.47s-23.47 10.53-23.47 23.47 10.53 23.47 23.47 23.47h11.47v89.52h-11.17c-3.68-15.27-13.43-26.64-23.68-38.6-15.21-17.75-30.94-36.1-30.13-70.83 0-.05 0-.09 0-.14 0-46.72 38.01-84.73 84.73-84.73s84.73 38.01 84.73 84.73v.14c.81 34.73-14.92 53.08-30.13 70.83zm-34.21-62.92v-11.47c0-6.33 5.15-11.47 11.47-11.47s11.47 5.15 11.47 11.47c0 6.33-5.15 11.47-11.47 11.47zm-26.4-124.41v-25.95c0-3.31 2.69-6 6-6s6 2.69 6 6v25.95c0 3.31-2.69 6-6 6s-6-2.68-6-6zm-112.75 124.75h-25.95c-3.31 0-6-2.69-6-6s2.69-6 6-6h25.96c3.31 0 6 2.69 6 6s-2.69 6-6.01 6zm21.11 50.38c1.66 2.87.67 6.54-2.2 8.2l-22.48 12.98c-.94.55-1.98.8-2.99.8-2.07 0-4.09-1.08-5.2-3-1.66-2.87-.67-6.54 2.2-8.2l22.48-12.98c2.86-1.66 6.53-.67 8.19 2.2zm20.09-178.7c-1.66-2.87-.67-6.54 2.2-8.2s6.54-.67 8.2 2.2l12.98 22.48c1.66 2.87.67 6.54-2.2 8.2-.95.55-1.98.8-2.99.8-2.07 0-4.09-1.08-5.2-3zm-20.09 65.95c-1.11 1.92-3.13 3-5.2 3-1.02 0-2.05-.26-2.99-.8l-22.48-12.98c-2.87-1.66-3.85-5.33-2.2-8.2 1.66-2.87 5.32-3.85 8.2-2.2l22.48 12.98c2.86 1.66 3.85 5.33 2.19 8.2zm195.29 0c-1.66-2.87-.67-6.54 2.2-8.2l22.48-12.98c2.87-1.66 6.54-.67 8.2 2.2s.67 6.54-2.2 8.2l-22.48 12.98c-.94.55-1.98.8-2.99.8-2.08 0-4.1-1.08-5.21-3zm53.06 56.37c0 3.31-2.69 6-6 6h-25.96c-3.31 0-6-2.69-6-6s2.69-6 6-6h25.96c3.31 0 6 2.69 6 6zm-20.19 75.35c-1.11 1.92-3.13 3-5.2 3-1.02 0-2.05-.26-2.99-.8l-22.48-12.98c-2.87-1.66-3.85-5.33-2.2-8.2 1.66-2.87 5.33-3.85 8.2-2.2l22.48 12.98c2.86 1.67 3.84 5.33 2.19 8.2zm-76.34-181.19 12.98-22.48c1.66-2.87 5.32-3.85 8.2-2.2 2.87 1.66 3.85 5.33 2.2 8.2l-12.98 22.48c-1.11 1.92-3.13 3-5.2 3-1.02 0-2.05-.26-2.99-.8-2.88-1.66-3.86-5.33-2.21-8.2zm240.32 125.81h-32.41c.01-.27.01-.53.01-.8 0-16.54-13.46-30-30-30s-30 13.46-30 30c0 .27 0 .54.01.8h-32.41c-3.31 0-6 2.69-6 6v124.79c0 3.31 2.69 6 6 6h41.39c2.12 0 4.09-1.12 5.17-2.95s1.11-4.09.08-5.95c-1.46-2.64-2.24-5.65-2.24-8.7 0-9.92 8.07-18 18-18s18 8.07 18 18c0 3.04-.77 6.05-2.24 8.7-1.03 1.86-1 4.12.08 5.95s3.04 2.95 5.17 2.95h41.39c3.31 0 6-2.69 6-6v-45.04c0-2.1-1.1-4.05-2.9-5.14s-4.04-1.15-5.9-.17c-2.6 1.38-5.43 2.07-8.4 2.07-9.92 0-18-8.07-18-18s8.07-18 18-18c2.97 0 5.79.7 8.4 2.07 1.86.98 4.1.92 5.9-.17s2.9-3.04 2.9-5.14v-37.3c0-3.28-2.69-5.97-6-5.97zm-6 34.99c-1.71-.3-3.46-.46-5.2-.46-16.54 0-30 13.46-30 30s13.46 30 30 30c1.75 0 3.49-.15 5.2-.46v30.72h-26.93c.35-1.84.53-3.72.53-5.6 0-16.54-13.46-30-30-30s-30 13.46-30 30c0 1.88.18 3.76.53 5.6h-26.93v-112.79h33.38c1.89 0 3.67-.89 4.81-2.41 1.13-1.52 1.48-3.48.95-5.29-.49-1.65-.73-3.37-.73-5.1 0-9.92 8.07-18 18-18s18 8.07 18 18c0 1.73-.25 3.45-.73 5.11-.54 1.81-.18 3.77.95 5.29s2.91 2.41 4.81 2.41h33.38v22.98zm-107.21-270.26c2.34 2.34 2.34 6.14 0 8.49l-33.13 33.13c-1.12 1.12-2.65 1.76-4.24 1.76s-3.12-.63-4.24-1.76l-19.8-19.8c-2.34-2.34-2.34-6.14 0-8.49 2.34-2.34 6.14-2.34 8.49 0l15.55 15.56 28.89-28.89c2.34-2.35 6.14-2.35 8.48 0zm119.21 80.14v-26.58c0-3.31-2.69-6-6-6h-83.61c3.65-8.19 5.69-17.24 5.69-26.76 0-36.39-29.61-66-66-66s-66 29.61-66 66 29.61 66 66 66c4.49 0 8.88-.45 13.12-1.31v92.87c0 3.31 2.69 6 6 6h41.39c2.12 0 4.09-1.12 5.17-2.95s1.11-4.09.08-5.95c-1.46-2.64-2.24-5.65-2.24-8.7 0-9.92 8.07-18 18-18s18 8.07 18 18c0 3.04-.77 6.05-2.24 8.7-1.03 1.86-1 4.12.08 5.95s3.04 2.95 5.17 2.95h41.39c3.31 0 6-2.69 6-6v-40.66c15.45-.5 27.86-13.21 27.86-28.78s-12.41-28.28-27.86-28.78zm-203.91-59.33c0-29.77 24.22-54 54-54s54 24.22 54 54-24.22 54-54 54c-29.78-.01-54-24.23-54-54zm202.98 104.91c-1.26 0-2.52-.14-3.74-.42-1.78-.4-3.65.02-5.07 1.16s-2.26 2.86-2.26 4.69v41.21h-26.93c.35-1.84.53-3.72.53-5.6 0-16.54-13.46-30-30-30s-30 13.46-30 30c0 1.88.18 3.76.53 5.6h-26.93v-90.54c11.35-4.69 21.11-12.46 28.25-22.26h84.55v27.13c0 1.82.83 3.55 2.26 4.69s3.29 1.57 5.07 1.16c1.22-.28 2.48-.42 3.74-.42 9.26 0 16.79 7.53 16.79 16.79 0 9.27-7.53 16.81-16.79 16.81z"></path>
                </svg>
              </div>
              <div class="right-side">
                <b>Advies</b>
              </div>
            </div>
          </router-link>
          <router-link to="/diensten#fiscaal">
            <div class="single-doel df">
              <div class="left-side">
                <svg id="fi_13378572" enable-background="new 0 0 64 64" viewBox="0 0 64 64"
                     xmlns="http://www.w3.org/2000/svg">
                  <g fill="#020202">
                    <path
                        d="m55.78 29.99v-8.23c0-.54-.43-.97-.97-.97s-.97.43-.97.97v8.23h-2.28v-6.45c0-.54-.43-.97-.97-.97s-.97.43-.97.97v6.45h-2.28v-4.06c0-.54-.43-.97-.97-.97s-.97.43-.97.97v4.06h-2.28v-1.97c0-.54-.43-.97-.97-.97s-.97.43-.97.97v1.97h-.9c-.54 0-.97.43-.97.97s.43.97.97.97h16.83c.54 0 .97-.43.97-.97s-.43-.97-.97-.97z"></path>
                    <path
                        d="m42.31 24.95c.24 0 .48-.09.66-.26l3.17-2.98 3.3-.48c.21-.03.41-.13.56-.28l2.47-2.55-.01.41c-.01.54.41.98.95.99h.02c.53 0 .96-.42.97-.95l.07-2.87c.01-.27-.1-.53-.29-.72-.15-.14-.33-.21-.54-.24-.05-.01-.1-.03-.15-.03-.01 0-.01 0-.02 0s-.01 0-.02 0l-2.87.14c-.53.03-.95.48-.92 1.02s.48.95 1.02.92l.39-.02-2.24 2.31-3.28.48c-.2.03-.38.12-.52.25l-3.39 3.19c-.39.37-.41.98-.04 1.37.2.2.45.3.71.3z"></path>
                    <path
                        d="m59.44 15.38c-4.16-6.5-10.6-10.99-18.14-12.65-.51-.12-1.04.22-1.15.74l-5.98 27.26c-.08.34.04.69.29.92l20.6 18.82c.19.17.42.25.65.25.26 0 .52-.11.71-.31 3.41-3.7 5.8-8.3 6.89-13.28 1.66-7.53.28-15.26-3.87-21.75zm1.98 21.33c-.95 4.33-2.94 8.34-5.78 11.66l-19.46-17.77 5.65-25.75c6.62 1.7 12.27 5.78 15.97 11.57 3.88 6.06 5.17 13.27 3.62 20.29z"></path>
                    <path
                        d="m29.95 32.08 5.86-26.71c.05-.25.01-.51-.13-.73s-.36-.37-.61-.42c-15.55-3.42-30.98 6.45-34.4 22.01-1.7 7.76-.1 15.49 3.87 21.71.01.01.01.03.02.04.02.02.04.04.05.06 3.99 6.2 10.33 10.88 18.08 12.58 2.04.45 4.11.67 6.16.67 8.03 0 15.84-3.36 21.35-9.41.36-.4.33-1.01-.06-1.37zm-27.38-5.44c2.76-12.57 13.93-21.17 26.31-21.17 1.59 0 3.21.14 4.83.44l-5.68 25.9-22.33 14.29c-3.35-5.66-4.65-12.54-3.13-19.46zm20.54 32.09c-6.91-1.52-12.62-5.58-16.36-10.99l22.03-14.1 19.32 17.64c-6.45 6.59-15.94 9.44-24.99 7.45z"></path>
                  </g>
                </svg>
              </div>
              <div class="right-side">
                <b>Fiscaal</b>
              </div>
            </div>
          </router-link>
          <router-link to="/diensten#administratie">
            <div class="single-doel df">
              <div class="left-side">
                <svg id="fi_10771610" height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M122.272,26.5,104.932,9.169a1.928,1.928,0,0,0-1.24-.506H66.755a4.417,4.417,0,0,0-4.412,4.412v9.338l-1.884-1.884a1.748,1.748,0,0,0-2.474,0l-4.817,4.815a29.836,29.836,0,0,0-2.951-1.214V17.307a1.749,1.749,0,0,0-1.75-1.75h-15.4a1.749,1.749,0,0,0-1.75,1.75V24.13a30.054,30.054,0,0,0-2.952,1.214l-4.816-4.815a1.748,1.748,0,0,0-2.474,0L10.187,31.417a1.748,1.748,0,0,0,0,2.474L15,38.7a27.916,27.916,0,0,0-1.216,2.957H6.965a1.75,1.75,0,0,0-1.75,1.75v15.4a1.75,1.75,0,0,0,1.75,1.75H13.78A27.154,27.154,0,0,0,15,63.518l-4.809,4.809a1.748,1.748,0,0,0,0,2.474L21.075,81.689a1.748,1.748,0,0,0,2.474,0l4.811-4.811c.14.068.286.127.428.193v35.246a7.028,7.028,0,0,0,7.021,7.02H108.55a7.029,7.029,0,0,0,7.021-7.02v-24.8h2.8a4.417,4.417,0,0,0,4.412-4.412V27.743A1.863,1.863,0,0,0,122.272,26.5ZM116.812,26H106.366a.922.922,0,0,1-.921-.921V14.638C106.607,15.8,101.234,10.431,116.812,26ZM26.785,73.5l-4.473,4.473L13.9,69.564l4.473-4.473a1.752,1.752,0,0,0,.3-2.076,23.819,23.819,0,0,1-1.933-4.7,1.75,1.75,0,0,0-1.679-1.257H8.715v-11.9h6.343a1.75,1.75,0,0,0,1.678-1.254A24.475,24.475,0,0,1,18.673,39.2a1.751,1.751,0,0,0-.3-2.071L13.9,32.654l8.413-8.413,4.473,4.472a1.746,1.746,0,0,0,2.06.307,26.348,26.348,0,0,1,4.73-1.945A1.751,1.751,0,0,0,34.817,25.4V19.057h11.9V25.4a1.751,1.751,0,0,0,1.242,1.675,26.278,26.278,0,0,1,4.729,1.945,1.746,1.746,0,0,0,2.061-.307l4.473-4.472,8.413,8.413-4.472,4.472a1.751,1.751,0,0,0-.3,2.071A24.475,24.475,0,0,1,64.8,43.905a1.75,1.75,0,0,0,1.678,1.254h6.343V56.9H58.8A18.941,18.941,0,1,0,28.788,65.78v7.388A1.752,1.752,0,0,0,26.785,73.5Zm85.286-2.348L82.993,83.409a4.1,4.1,0,0,0-3.952-3.043H65.318A4.088,4.088,0,0,0,61.38,83.4L32.288,71.154V63.92A3.526,3.526,0,0,1,35.809,60.4H108.55a3.525,3.525,0,0,1,3.521,3.521Zm-47.346,13.3a.593.593,0,0,1,.593-.592H79.041a.6.6,0,0,1,.606.592v7.8a.6.6,0,0,1-.606.593H65.318a.594.594,0,0,1-.593-.593ZM55.09,56.9H35.809a7.079,7.079,0,0,0-6.558,4.511,15.291,15.291,0,0,1-3.924-10.294A15.441,15.441,0,1,1,55.09,56.9Zm56.981,55.418a3.524,3.524,0,0,1-3.521,3.52H35.809a3.525,3.525,0,0,1-3.521-3.52V74.952L61.225,87.137v5.12a4.1,4.1,0,0,0,4.093,4.093H79.041a4.1,4.1,0,0,0,4.106-4.093V87.142l28.924-12.189Zm6.3-28.3h-2.8V63.92A7.029,7.029,0,0,0,108.55,56.9H76.319V43.409a1.749,1.749,0,0,0-1.75-1.75H67.752A27.911,27.911,0,0,0,66.537,38.7l4.81-4.811a1.748,1.748,0,0,0,0-2.474l-5.5-5.5V13.075a.913.913,0,0,1,.912-.912h35.19V25.078a4.426,4.426,0,0,0,4.421,4.421h12.919V83.1A.914.914,0,0,1,118.373,84.012Z"></path>
                </svg>
              </div>
              <div class="right-side">
                <b>Administratie</b>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <br>

    <section class="zekerheden">
      <div class="container">
        <h3>
          <strong>
            Mijn kernwaarden
          </strong>
        </h3>
        <div class="items-grid">
          <div class="single-item">
            <svg fill="none" height="24" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M11 16L13 18L19 12M1 18V17C1 14.2386 3.23858 12 6 12H9.75M12 5C12 7.20914 10.2091 9 8 9C5.79086 9 4 7.20914 4 5C4 2.79086 5.79086 1 8 1C10.2091 1 12 2.79086 12 5Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <h5><strong>Persoonlijke aandacht</strong></h5>
            <p>Bij HN Accountancy staan u en uw bedrijf centraal. Ik luister naar uw wensen, denk met u mee en neem de
              tijd om uw behoefte in kaart te brengen. Of u nu een kleine of grote onderneming heeft, u krijgt altijd de
              dienstverlening die bij u past - met dezelfde persoonlijke aandacht. </p>
          </div>
          <div class="single-item">
            <svg fill="none" height="24" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M5.34875 9.50002L7.34875 11.5L11.5 7.34878M7.72528 1.07852L1.72528 2.7928C1.29598 2.91546 1 3.30784 1 3.75432L1 8.85384C1 12.0834 2.55966 15.1141 5.18762 16.9912L7.41876 18.5849C7.76646 18.8332 8.23354 18.8332 8.58124 18.5849L10.8124 16.9912C13.4403 15.1141 15 12.0834 15 8.85384V3.75432C15 3.30784 14.704 2.91546 14.2747 2.7928L8.27472 1.07852C8.09517 1.02721 7.90483 1.02721 7.72528 1.07852Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <h5><strong>Deskundig en Betrouwbaar</strong></h5>
            <p>Deskundigheid en betrouwbaar vormen de basis van mijn dienstverlening. Met actuele kennis, ervaring en
              professionele aanpak bouw ik graag een duurzame relatie met u op.</p>
          </div>
          <div class="single-item">
            <svg fill="none" height="24" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M1 15V14C1 11.7909 2.79086 10 5 10H9C11.2091 10 13 11.7909 13 14V15M13 7C14.6569 7 16 5.65685 16 4C16 2.34315 14.6569 1 13 1M19 15V14C19 11.7909 17.2091 10 15 10H14.5M10 4C10 5.65685 8.65685 7 7 7C5.34315 7 4 5.65685 4 4C4 2.34315 5.34315 1 7 1C8.65685 1 10 2.34315 10 4Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <h5><strong>Duidelijke Communicatie</strong></h5>
            <p>Geen ingewikkelde vaktaal, maar heldere en begrijpelijke uitleg. Zo weet u altijd waar u aan toe bent en
              kunt u met vertrouwen beslissingen nemen.</p>
          </div>
          <div class="single-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 11V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="7.5" r="1" fill="white"/>
            </svg>
            <h5><strong>Proactief Meedenken</strong></h5>
            <p>Ik kijk verder dan alleen de cijfers. Of het nu gaat om belastingvoordelen, kostenbesparingen of
              groeikansen, ik denk met u mee en help u vooruit.</p>
          </div>
          <div class="single-item">
            <svg fill="none" height="24" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M9.04894 1.92705C9.3483 1.00574 10.6517 1.00574 10.9511 1.92705L12.2451 5.90983C12.379 6.32185 12.763 6.60081 13.1962 6.60081H17.3839C18.3527 6.60081 18.7554 7.84043 17.9717 8.40983L14.5838 10.8713C14.2333 11.126 14.0866 11.5773 14.2205 11.9894L15.5146 15.9721C15.8139 16.8934 14.7595 17.6596 13.9757 17.0902L10.5878 14.6287C10.2373 14.374 9.7627 14.374 9.41221 14.6287L6.02426 17.0902C5.24054 17.6596 4.18607 16.8934 4.48542 15.9721L5.7795 11.9894C5.91338 11.5773 5.76672 11.126 5.41623 10.8713L2.02827 8.40983C1.24456 7.84043 1.64734 6.60081 2.61606 6.60081H6.8038C7.23703 6.60081 7.62099 6.32185 7.75486 5.90983L9.04894 1.92705Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
            <h5><strong>Resultaatgericht</strong></h5>
            <p>Samen werken we aan een financieel gezonde toekomst. Ik focus niet alleen op de cijfers, maar op wat ze
              voor uw bedrijf betekenen. Met praktische en strategische adviezen help ik u om uw doelen te bereiken.</p>
          </div>
        </div>
      </div>
    </section>

    <br>
    <br>
    <section class="text-image" style="flex-direction: row-reverse">
      <div class="container">
        <div class="text-side">
          <h1 class="page-title"><strong style="font-weight: 800">Kopje koffie? Laten we vrijblijvend kennismaken</strong><br></h1>
          <span class="stripe"></span>
          <p>Heeft u een vraag over uw administratie, fiscale zaken of zoekt u financieel advies? Ik help u graag
            verder. <br><br>Neem vrijblijvend contact op en ontdek wat HN Accountancy voor u kan betekenen. Tijdens een
            kennismakingsgesprek kijken we of we een klik met elkaar hebben en inventariseren we uw behoeften.</p>
        </div>
        <div class="img-side">
          <img alt="" src="/img/logo.png"
               style="border-radius: 30px 70px; width: 100%; min-width: 350px;">
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>

$blue: #498E75;
$blue-d2: #498E75;
$coal: #498E75;

.diensten-home {
  margin-top: 40px;
  margin-bottom: 40px;

  h2 {
    text-align: center;
    margin-bottom: 24px;
  }

  .container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
  }
}

.df {
  display: flex;
}

.portfolio-item {
  grid-column: span 2;
  display: flex;
  width: 100%;
  height: 100px;
  position: relative;
  max-height: 250px;
  min-height: 250px;
  @media (max-width: 900px) {
    min-height: 350px;
    max-height: 350px;
  }

  &:hover {
    img {
      filter: brightness(0.7);
    }
  }

  img {
    width: 100%;
    height: 100% !important;
    object-fit: cover;
    transition: .2s;
    filter: brightness(0.3);
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(47.13deg, rgba(30, 30, 30, 0.55) 0%, rgba(207, 215, 255, 0) 100%);
    z-index: 1;
  }
}

.introduction-image {
  img {
    width: 100%;
    height: 450px;
    object-fit: cover;
    filter: brightness(0.5);
  }

  .centered-text {
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    text-align: center;
    width: 100%;
    padding: 0 20px;
    z-index: 9;

    h1 {
      font-size: 60px;
      @media (max-width: 600px) {
        font-size: 45px;
        line-height: 50px;
      }
      @media (max-width: 440px) {
        font-size: 35px;
        line-height: 40px;
      }
      color: white;
      font-weight: 500;
      margin-bottom: 20px;
      text-transform: uppercase;
      line-height: 60px;
    }

    p {
      font-size: 24px;
      color: white;
      font-weight: 500;
    }
  }
}

.zekerheden {
  background-color: rgba(179, 217, 255, 0.15);

  .container {
    padding-top: 70px;
    padding-bottom: 70px;

    b {
      color: #2D9BF3;
      font-size: 16px;
    }

    h3 {
      margin-top: 10px;
      font-weight: 500;
      font-size: 42px;
    }

    .items-grid {
      margin-top: 50px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px 80px;
      @media (max-width: 950px) {
        grid-template-columns: 1fr;
      }

      .single-item {
        border-left: solid 2px #2D9BF3;
        min-height: 140px;
        height: auto;
        display: grid;
        align-items: stretch;
        padding-left: 15px;

        h5 {
          font-weight: 800;
          font-size: 22px;
          margin-top: 10px;
        }

        p {
          margin-top: -5px;
          color: #6B87A4;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
}

.doelen {
  padding: 100px 0;

  @media (max-width: 850px) {
    padding: 0;
  }

  .doelen-headline {
    justify-content: space-between;
    align-items: center;
    gap: 50px;
    @media (max-width: 850px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }

    a {
      color: $blue;
    }

    h4 {
      font-size: 42px;
    }
  }

  .doelen-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    margin-top: 40px;


    @media (max-width: 1050px) {
      gap: 25px;
    }
    @media (max-width: 850px) {
      grid-template-columns: 1fr;
    }

    a {
      text-decoration: none;
    }

    .single-doel {
      gap: 16px;
      border-radius: 4px;
      background: #FFF;
      box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.09);
      padding: 26px;

      &:hover {
        box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.15);
      }

      .right-side {
        display: flex;
        align-items: center;
      }

      @media (max-width: 850px) {
        flex-direction: column;
      }

      a {
        color: $blue;
      }

      b {
        font-size: 28px;
        font-weight: 600;
      }

      p {
        font-size: 16px;
      }

      img, svg {
        width: 80px;
        height: 80px;
      }
    }
  }
}

.itemlist {
  @media (max-width: 980px) {

    padding: 0 !important;
  }

  @media (max-width: 980px) and (min-width: 700px) {
    margin-top: 130px;
  }
}

.aanbod {

  h3 {
    text-align: center;
    color: #000F3A;
    padding-bottom: 24px;
    font-weight: 700;
  }

  .img-side {
    position: relative;
    max-height: 700px;

    .img-overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      max-height: 600px;
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.4);
      width: 100%;
      height: 100%;
      transition: .3s;
      //max-width: 600px;
      min-height: 500px;

      .overlay-text {
        position: absolute;
        bottom: 24px;
        left: 24px;

        p, a {
          color: white;
        }

        .overlay-title {
          font-size: 36px;
          font-weight: 600;
        }

        .overlay-desc {
          font-size: 18px;
          font-weight: 500;
          padding-right: 16px;
        }

        a {
          display: inline-block;
          margin-top: 6px;
        }
      }
    }

    img {
      max-height: 600px;
      height: 100%;
      object-fit: cover;
      border-radius: 8px !important;
      position: relative;
    }
  }
}

.drie-items {
  .wow {
    .fact-item {
      background-color: #eaeaea !important;
      padding: 32px 8px !important;

      .fact-icon {
        margin-bottom: 16px;
      }
    }
  }
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 20px;
  @media (max-width: 1150px) {
    grid-template-columns: 1fr;
  }

  img {
    width: 100%
  }
}

.landing {
  .hero-banner-div {
    position: relative;
    @media (max-width: 600px) {
      height: 300px;
    }

    .hero-banner {
      width: 100%;
      margin-top: -100px;
      min-height: 100%;
      object-fit: cover;
      @media (max-width: 750px) {
        margin-top: 20px;
      }
    }

    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(34, 34, 34, 0.4);
    }
  }

  .hero-image {
    img {
      //max-width: 600px;
      border-radius: 8px;
    }

    a {
      font-weight: 600;
    }
  }

  .hero-navigator {
    background-color: white;
    width: 100%;
    margin-top: -200px;
    position: relative;
    padding: 45px 60px 60px;
    box-shadow: 0 4px 4px rgba(197, 197, 197, 0.25);

    @media (max-width: 1450px) {
      max-width: 90vw;
      margin-top: -170px;
    }

    @media (max-width: 1200px) {
      margin-top: -100px;
    }

    @media (max-width: 1000px) {
      max-width: 95vw;
      margin-top: -70px;
    }

    @media (max-width: 900px) {
      margin-top: 0;
    }

    @media (max-width: 750px) {
      padding: 25px;
      max-width: 90vw;
      margin-top: -60px;
    }


    .headline {
      h1 {
      }

      p {
        margin-bottom: 15px;
        color: #656565;

        @media (max-width: 750px) {
          margin-top: 20px;
          font-size: 20px;
        }

      }

      hr {
        border: none;
        background-color: $blue;
        width: 40px;
        height: 3px;
        margin: 0;
      }
    }

    .navigators {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      gap: 30px;
      height: 230px;
      position: relative;
      @media (max-width: 1450px) {
        height: 180px;
      }

      @media (max-width: 1200px) {
        height: 150px;
      }

      @media (max-width: 750px) {
        display: grid;
        height: unset;
        .different-navigator {
          height: 200px !important;
        }
      }


      .different-navigator {
        &::before {
          clip-path: polygon(88% 0, 100% 17%, 100% 100%, 0 100%, 0 0);
          background: #222222 !important;
        }

        &::after {
          clip-path: polygon(88% 0, 100% 17%, 100% 100%, 0 100%, 0 0);
        }
      }

      a {
        flex: 0 1 100%;
        cursor: default;
      }

      .single-navigator {
        width: 100%;
        height: 100%;
        max-width: 100%;
        position: relative;
        z-index: 4;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          background: linear-gradient(47.13deg, rgba(30, 30, 30, 0.8) 0%, rgba(207, 215, 255, 0) 97.4%);
          z-index: 1;
        }

        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .zekerheden {
    background-color: $blue-d2;

    .container {
      padding-top: 70px;
      padding-bottom: 70px;

      b {
        color: $coal;
        font-size: 16px;
      }

      h3 {
        margin-top: 10px;
        font-weight: 800;
        font-size: 42px;
        color: white;
      }

      .items-grid {
        margin-top: 50px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px 80px;
        @media (max-width: 950px) {
          grid-template-columns: 1fr;
        }

        .single-item {
          border-left: solid 2px $coal;
          min-height: 140px;
          height: auto;
          display: grid;
          align-items: stretch;
          padding-left: 15px;

          h5 {
            font-weight: 800;
            font-size: 22px;
            margin-top: 10px;
            color: white;
          }

          p {
            margin-top: 5px;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }
    }
  }

  .social-media {
    margin: 50px 0 100px;

    .container {
      .social-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (max-width: 950px) {
          align-items: flex-start;
          flex-direction: column;
          gap: 20px;
        }

        a {
          text-decoration: none;
          font-family: 'Avenir LT Std', sans-serif;
        }

        .right-side {
          height: auto;

          a {
            align-items: center;
            padding: 12px 50px;
            font-weight: 700;
            font-size: 20px;
            color: white;
            background-color: $blue;
            transition: .25s ease;

            &:hover {
              background-color: darken($blue, 15%);
            }
          }
        }

        .left-side {
          a {
            color: #474747;
            font-size: 22px;
            font-weight: 500;
          }

          h4 {
            font-weight: 900;
            font-size: 42px;
            color: #222222;
          }
        }
      }

      .social-content {
        display: grid;
        margin-top: 70px;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(2, 1fr);
        @media (max-width: 950px) {
          display: block;
          height: unset;
          .div4, .div5, .div5, .div6, .div7, .div8 {
            display: none;
          }
        }
        height: 400px;
        gap: 35px;

        div {
          background: rgba(217, 217, 217, 0.6);
          overflow: hidden;
        }

        img {
          width: 100%;
          margin: auto;
          object-fit: cover;
          height: 100%;
        }
      }

      .div1 {
        grid-area: 1 / 1 / 2 / 2;
      }

      .div2 {
        grid-area: 2 / 1 / 3 / 2;
      }

      .div3 {
        grid-area: 1 / 2 / 3 / 4;
      }

      .div4 {
        grid-area: 1 / 4 / 2 / 5;
      }

      .div5 {
        grid-area: 1 / 5 / 2 / 6;
      }

      .div6 {
        grid-area: 2 / 5 / 3 / 6;
      }

      .div7 {
        grid-area: 2 / 4 / 3 / 5;
      }
    }
  }

  .faq-section {
    .total-faq-headline {
      padding: 40px 0;
      background-color: $blue;
      margin-bottom: 50px;

      .container {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .pill {
          width: fit-content;
          background-color: #DEEBFF;
          color: $blue;
          font-weight: 800;
          font-size: 16px;
          margin-bottom: 20px;
          cursor: default;
          border: none;
          padding: 10px 16px 8px;
          border-radius: 28px;
          font-family: 'Avenir LT Std', sans-serif;
        }

        h3, p {
          color: white;
        }

        h3 {
          font-size: 26px;
        }

        p {
          margin-top: 15px;
          font-family: 'Urbane', sans-serif;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .faq-content {
      .container {
        display: flex;
        flex-direction: column;
        max-width: 900px;

        .single-faq-item {
          cursor: pointer;
          overflow: hidden;
          border-top: solid 1px #ECEFF1;
          padding: 40px 0;

          .faq-headline {
            display: flex;
            justify-content: space-between;
            padding: 16px;

            h4 {
              font-size: 28px;
              font-weight: 600;
              @media (max-width: 700px) {
                font-size: 24px;
              }
            }

            svg {
              transition: .3s;
              transform: rotate(90deg);
              margin-right: 15px;
            }
          }

          .faq-content {
            font-size: 18px;
            font-weight: 300;
            padding: 0;
            height: 0;
            opacity: 0;
            transition: all .2s ease;
            overflow: hidden;
          }
        }

        .active-faq {
          .faq-headline {
            svg {
              transform: rotate(-90deg);
            }
          }

          .faq-content {
            height: auto;
            padding: 0 16px;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>

<script>

// @ is an alias to /src
import AOS from "aos";

import TextImage from '@/components/TextImage.vue'
import Voordelen from "@/components/Voordelen";

export default {
  name: 'HomeView',
  components: {
    Voordelen,
    TextImage
  },
  data() {
    return {
      showedFaq: false,
    }
  },
  created() {
    window.scrollTo(0, 0)
  },
  methods: {
    toggleFaq(id) {
      console.log(id)
      let selectedFaq = document.getElementById('faq-' + id)

      if (selectedFaq.classList.contains('active-faq')) {
        selectedFaq.classList.remove('active-faq')
      } else {
        selectedFaq.classList.add('active-faq')
      }

      this.showedFaq = !this.showedFaq
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    AOS.init();
  }
}
</script>
